module.exports = __webpack_public_path__ + "static/img/xzqm.f04a842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xzqm.png
// module id = 7hkQ
// module chunks = 0